import { ChangeDetectionStrategy, Component, computed, input, output, signal } from '@angular/core';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { MessageWithAttachmentsDtoStatus } from '../../../services/api.clients.generated';

interface StatusOption {
  value: MessageWithAttachmentsDtoStatus;
  labelKey: string;
  color: string;
}

const STATUS_OPTIONS: readonly StatusOption[] = [
  { value: MessageWithAttachmentsDtoStatus.OPEN, labelKey: 'message.status.open', color: '#2f9e6f' },
  { value: MessageWithAttachmentsDtoStatus.HANDLED, labelKey: 'message.status.handled', color: '#8294a0' }
];

/** Pill dropdown to change a message status (Ouvert / Traité). Presentational. */
@Component({
  selector: 'app-status-select',
  imports: [OverlayModule, MatIcon, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './status-select.component.html',
  styleUrl: './status-select.component.scss'
})
export class StatusSelectComponent {
  readonly status = input.required<MessageWithAttachmentsDtoStatus>();
  readonly statusChange = output<MessageWithAttachmentsDtoStatus>();

  protected readonly options = STATUS_OPTIONS;
  protected readonly open = signal(false);
  protected readonly current = computed(() =>
    STATUS_OPTIONS.find(option => option.value === this.status()) ?? STATUS_OPTIONS[0]
  );

  protected toggle(): void {
    this.open.update(value => !value);
  }

  protected close(): void {
    this.open.set(false);
  }

  protected select(value: MessageWithAttachmentsDtoStatus): void {
    this.close();
    if (value !== this.status()) {
      this.statusChange.emit(value);
    }
  }
}
